import Axios, { AxiosObservable } from "axios-observable"
import { ICompanyConfig, IResponse } from "interfaces"

export const getCompanyConfig = (): AxiosObservable<IResponse<ICompanyConfig>> => {
  return Axios.post('/list-company-configuration');
};